// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"SearchForm_formContainer__1v3--","searchFormWrapper":"SearchForm_searchFormWrapper__DbgzP","formBody":"SearchForm_formBody__bS6JG"};